import { Stethoscope, PhoneCall, ShieldCheck } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const ITEMS = [
  { icon: Stethoscope, text: "Not medical advice" },
  { icon: PhoneCall, text: "Call 911 in an emergency" },
  { icon: ShieldCheck, text: "Data stays on your device" },
];

export const TrustStrip = () => (
  <FadeUp>
    <div data-testid="trust-strip" className="relative bg-transparent">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <ul className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-3 sm:gap-0 text-sm text-[#e3e8f0]">
          {ITEMS.map((it, i) => (
            <li key={it.text} className="flex items-center justify-center gap-2.5 sm:px-8" data-testid={`trust-item-${i}`}>
              {i > 0 && <span className="hidden sm:block -ml-8 mr-8 h-1 w-1 rounded-full bg-[#b7c2d4]/50" aria-hidden="true" />}
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-[var(--clinical)]">
                <it.icon size={15} strokeWidth={1.75} />
              </span>
              {it.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </FadeUp>
);
